"use strict";

var _regeneratorRuntime = require("/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getImages_1 = require("./utils/getImages");

var options_1 = require("./options");

exports.getBase64Strings = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
    var _ref2,
        _ref2$maxSize,
        maxSize,
        canvas,
        context,
        images,
        base64s,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref2$maxSize = _ref2.maxSize, maxSize = _ref2$maxSize === void 0 ? options_1.defaultOptions.maxSize : _ref2$maxSize;
            canvas = document.createElement('canvas');
            context = canvas.getContext('2d');

            if (context) {
              _context.next = 5;
              break;
            }

            throw new Error('canvas can not created');

          case 5:
            _context.next = 7;
            return getImages_1.getImages(files);

          case 7:
            images = _context.sent;
            base64s = images.map(function (image) {
              var orientation = getImages_1.getOrientation(image);

              var _getImages_1$getSize = getImages_1.getSize(orientation > 4 ? image.height : image.width, orientation > 4 ? image.width : image.height, maxSize),
                  width = _getImages_1$getSize.width,
                  height = _getImages_1$getSize.height;

              canvas.setAttribute('width', "".concat(width, "px"));
              canvas.setAttribute('height', "".concat(height, "px"));

              var _getImages_1$getCanva = getImages_1.getCanvasOptions(width, height, orientation),
                  translate = _getImages_1$getCanva.translate,
                  scale = _getImages_1$getCanva.scale,
                  rotate = _getImages_1$getCanva.rotate;

              context.translate(translate.x, translate.y);
              context.scale(scale.x, scale.y);
              context.rotate(rotate.angle); // exif orientation values > 4 correspond to portrait orientation.
              // width and height parameters must be swapped for landscape to ensure correct image display

              if (orientation > 4) {
                context.drawImage(image, 0, 0, height, width);
              } else {
                context.drawImage(image, 0, 0, width, height);
              }

              return canvas.toDataURL('image/jpeg');
            });
            return _context.abrupt("return", base64s);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();